// 学员登记表
import axios from '@/utils/edu_request'
import qs from 'qs'
// 请求课程列表接口
export function getPersonal(params) {
  return axios({
    url: '/personal/student/save',
    dataType: 'json',
    method: 'post',
    data: qs.stringify(params)

  })
}
export function get_info(params) {
  return axios({
    url: '/personal/student/info',
    dataType: 'json',
    method: 'GET',
    params

  })
}
export function getAddress(params) {
  return axios({
    url: '/city/Getcitylist',
    dataType: 'json',
    method: 'GET',
    params

  })
}
export function classStudentScore(params) {
  return axios({
    url: '/lesson/lesson/classStudentScore',
    dataType: 'json',
    method: 'GET',
    params

  })
}
